import React from 'react'
import { useStyles } from './styles'
import { AnimalGenderIcon, CowFaceIcon, CowIcon } from 'src/assets/svg'

type CardType = 'registered' | 'roof' | 'births'

type CardProps = {
  type: CardType
  label: string
  value?: number | null
  loading?: boolean
}

const iconMap: Record<CardType, React.ReactNode> = {
  registered: <CowFaceIcon />,
  roof: <AnimalGenderIcon />,
  births: <CowIcon />
}

export const Card = React.memo(({ type, label, value, loading }: CardProps) => {
  const style = useStyles()

  const displayValue = loading ? '...' : value ?? 0

  return (
    <div className={style.cardContainer}>
      <div className={style.cardContent}>
        <div className={style.cardIcons}>
          <span>{iconMap[type]}</span>
          <div className={style.cardInfoContainer}>
            <span className={style.cardInfoTextTotal}>{displayValue}</span>
            <label className={style.cardInfoTextLabel}>{label || '—'}</label>
          </div>
        </div>
      </div>
    </div>
  )
})

Card.displayName = 'Card'
